import React from 'react';
import ReactMarkdown from 'react-markdown';
import '../../ChatbotStyles/MarkdownContent.scss';

interface MarkdownContentProps {
  content: string;
}

const formatTitle = (text: string) =>
  text.replace(/[_:]/g, ' ').replace(/\s+/g, ' ').trim().toUpperCase();

export const preprocess = (raw: string): string => {
  let text = raw.replace(
    /^\s*-\s*\*\*(.+?):\*\*\s*/gm,
    (_, label) => `### ${formatTitle(label)}\n\n`,
  );

  text = text.replace(
    /^\s*\*\*([A-Za-z_][A-Za-z0-9_ ]*):\*\*\s*/gm,
    (_, label) => `## ${formatTitle(label)}\n\n`,
  );

  return text;
};

export const MarkdownContent = ({ content }: MarkdownContentProps) => {
  if (!content) return null;

  return (
    <div className="markdown-content">
      <ReactMarkdown
        skipHtml
        components={{
          h2: ({ children }) => <div className="md-heading">{children}</div>,
          h3: ({ children }) => (
            <div className="md-sub-block">
              <div className="md-subheading">{children}</div>
            </div>
          ),
        }}
      >
        {preprocess(content)}
      </ReactMarkdown>
    </div>
  );
};
